import HeightFade from './HeightFade'
import HeightFadeContainer from './HeightFadeContainer'

export default HeightFadeContainer(HeightFade)

export { HeightFade }
